import ErroHandler from './ErroHandler'

export default ErroHandler
